import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { PlansRepository } from "../../repositories";
import { InjectPlanLocationRequest } from '../../domain';


@Injectable({ providedIn: 'root' })
export class InjectPlanLocationsUsecase implements UseCase<InjectPlanLocationRequest,string> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(param: InjectPlanLocationRequest): Observable<string> {
    return this.planRepository.injectPlanLocations(param);
  }

}
